import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import plusIcon from '../../../../images/icons/plus.svg';
import minusIcon from '../../../../images/icons/minus.svg';
import styles from './CouponCode.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

class CouponCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      code: '',
    };
  }

  toggle = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  onChange = (event) => {
    this.setState({
      code: event.target.value,
    });
  };

  onCouponCodeAddClick = () => {
    const {
      orderNumber, guestToken, applyCouponCodeRequest,
    } = this.props;
    const { code } = this.state;

    applyCouponCodeRequest({ orderNumber, code, guestToken });
  };

  render() {
    const { expanded, code } = this.state;
    const { couponCodeErrorText, couponCodeSuccessText } = this.props;

    return (
      <div className={cx(styles['coupon-code'], expanded ? styles.active : null)}>
        <ClickableDiv className={styles.toggle} onClick={this.toggle}>
          <div className={styles.title}>Have a Coupon Code?</div>
          <img className={styles.toggler} src={expanded ? minusIcon : plusIcon} alt="Plus" />
        </ClickableDiv>
        <div className={styles.content}>
          <div className={styles.form}>
            <input type="text" value={code} onChange={this.onChange} />
            <button type="button" disabled={code.length === 0} onClick={this.onCouponCodeAddClick}>Add</button>
          </div>
          <div className={styles.result}>
            <div className={styles.success}>
              { couponCodeSuccessText }
            </div>
            <div className={styles.error}>
              { couponCodeErrorText }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CouponCode.propTypes = {
  applyCouponCodeRequest: PropTypes.func.isRequired,
  couponCodeErrorText: PropTypes.string,
  couponCodeSuccessText: PropTypes.string,
  guestToken: PropTypes.string,
  orderNumber: PropTypes.string,
};

export default CouponCode;
